
// { path: '', type: '', canShow?: (user) => boolean }

export default [];
